import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import fondeaLogoNavy from "@/assets/fondea-official-navy.png.asset.json";
import fondeaLogoWhite from "@/assets/fondea-official-white.png.asset.json";

interface FondeaLogoProps {
  /** Force a variant regardless of the active theme (useful over dark surfaces). */
  variant?: "auto" | "light" | "dark";
  className?: string;
}

/**
 * Official FONDEA by IBYLIT lockup. Uses the navy version on light backgrounds
 * and the white version on dark backgrounds.
 */
export function FondeaLogo({ variant = "auto", className = "h-10 w-auto" }: FondeaLogoProps) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDarkSurface =
    variant === "dark" || (variant === "auto" && mounted && resolvedTheme === "dark");

  const src = isDarkSurface ? fondeaLogoWhite.url : fondeaLogoNavy.url;

  return <img src={src} alt="FONDEA by IBYLIT" className={className} decoding="async" />;
}

export default FondeaLogo;
